import { VxeLayoutHeader } from 'vxe-pc-ui';
export default {
  name: 'XLayoutHeader',
  components: {
    VxeLayoutHeader
  }
};